@if (demoMode) { @if (variant() === 'bar') {
<div
  class="demo-notice demo-notice--bar"
  role="note"
  [attr.aria-label]="'demo.regionLabel' | transloco"
>
  <span class="demo-notice__badge">{{ 'demo.badge' | transloco }}</span>
  <p class="demo-notice__text">{{ 'demo.bar' | transloco }}</p>
</div>
} @else {
<div
  class="demo-notice demo-notice--card"
  role="note"
  [attr.aria-label]="'demo.regionLabel' | transloco"
>
  <p class="demo-notice__title">
    <span class="demo-notice__badge">{{ 'demo.badge' | transloco }}</span>
    {{ 'demo.title' | transloco }}
  </p>
  <ul class="demo-notice__list">
    <li>{{ 'demo.data' | transloco }}</li>
    <li>{{ 'demo.noSave' | transloco }}</li>
    @if (loginHint()) {
    <li>{{ 'demo.login' | transloco }}</li>
    }
  </ul>
</div>
} }
